import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CanvasState } from 'src/app/model/canvas-state';
import { CANVAS_STATES } from 'src/app/data/canvas-states';

@Injectable({
  providedIn: 'root'
})
export class CanvasStateService {

  private readonly _canvasState= new BehaviorSubject<CanvasState>(CANVAS_STATES);
  private _currentCanvasState: CanvasState;
  canvasState$ = this._canvasState.asObservable();


  get canvasState(): CanvasState {
    return this._canvasState.getValue();
  }

  set canvasState (val:CanvasState){
    this._canvasState.next(val);
  }
  
  setState(staticName: string, isActive: boolean, type=null){
    this._currentCanvasState.staticName=staticName;
    this._currentCanvasState.active = isActive;
    this._currentCanvasState.type = type;
    this._canvasState.next(this._currentCanvasState);
  }

  clearState(){
    this._currentCanvasState.staticName=null;
    this._currentCanvasState.active = null;
    this._canvasState.next(this._currentCanvasState);
  }

  // setActive(staticName: string, isActive: boolean){
  //   let canvasState=this._currentCanvasStates.find(_currentCanvasStates => _currentCanvasStates.staticName === staticName);
  //   let activeCanvasState=this.getActive();

  //   if(activeCanvasState && canvasState!=activeCanvasState){
  //     this.setActive(activeCanvasState.staticName,false);
  //   }
  //   if(canvasState){
  //     canvasState.active=isActive;
  //     const index = this._currentCanvasStates.indexOf(canvasState);
  //     this._currentCanvasStates[index]=canvasState;
  //     this._canvasStates.next(this._currentCanvasStates);
      
  //   }
    
    
  // }

  // getActive(){
  //   let canvasState=this._currentCanvasStates.find(_currentCanvasStates => _currentCanvasStates.active === true);
  //   return canvasState;
  // }

  // deactivate(){
  //   let activeCanvasState=this.getActive();
  //   if(activeCanvasState)
  //     this.setActive(activeCanvasState.staticName,false);
  // }

  constructor() {
    this._currentCanvasState = CANVAS_STATES;
  }

}
